module.exports = __webpack_public_path__ + "img/VRSC.e7114220.svg";